import L from "leaflet";

export const CustomVertexEditIcon = () => {
  return new L.DivIcon({
    html: `
      <div style="
        width: 16px; 
        height: 16px; 
        border-radius: 50%; 
        background: #086AA9; 
        border: 3px solid white; 
        box-shadow: 0 2px 4px rgba(0,0,0,0.3);
        cursor: pointer;
      "></div>
    `,
    className: "custom-edit-marker",
    iconSize: [16, 16],
    iconAnchor: [8, 8],
  });
};
